import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=a6fc83aa&"
import script from "./Detalle.vue?vue&type=script&lang=js&"
export * from "./Detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports